import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { DrawerFooterStyledProps } from 'types/layout';

const DrawerFooterStyled = styled(Box, { shouldForwardProp: prop => prop !== 'open' })(
    ({ theme, open }: DrawerFooterStyledProps) => ({
        ...theme.mixins.toolbar,
        display: 'flex',
        alignItems: 'center',
        justifyContent: open ? 'flex-start' : 'center',
        paddingLeft: theme.spacing(open ? 3 : 0),
    })
);

export default DrawerFooterStyled;
